import { defineStore } from 'pinia';
import { User, Credential, AuthState } from '@/types/auth';

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    user: null,
    credential: null,
  }),
  actions: {
    setUser(user: User) {
      this.user = user;
    },
    setCredential(credential: Credential) {
      this.credential = credential;
    },
    logout() {
      this.user = null;
      this.credential = null;
    },
  },
});
